// 科研助手相关接口地址（部署不同环境都要使用）
const AI_API_URL = 'https://chat.zhitulist.com/research-assistant-api';

/**************  服务器域名  ***************/
const BASE_PUBLIC_PATH = '/achievement-assistant';
const BASE_OUTPUT_DIR = 'achievement-assistant';
const ROUTER_BASE_URL = '/achievement-assistant/';
const REQUEST_BASE_URL = '/achievement-assistant-api';

module.exports = {
  BASE_PUBLIC_PATH,
  BASE_OUTPUT_DIR,
  ROUTER_BASE_URL,
  REQUEST_BASE_URL,

  AI_API_URL,
};
